/**
 * A form text input.
 *
 * Design:
 * https://www.figma.com/file/01KWBdMZg5QM9SRS1pQq0z/Design-System----Robot-Styles?node-id=10%3A45&t=0UmLxCkbgBxAQPdn-1
 *
 * Note, the styling from the design team is sufficiently different from MUI
 * that this is not based on that.
 * https://mui.com/material-ui/react-text-field/
 */

import React from 'react';

import * as S from './TextField.styles';

type TextFieldProps = {
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  disabled?: boolean;
};

export const TextField = ({
  placeholder,
  value,
  onChange,
  autoFocus,
  disabled,
}: TextFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <S.Input
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      autoFocus={autoFocus}
      disabled={disabled}
    />
  );
};
